import React from "react";

const MILESTONES = [
  {
    year: "2024",
    title: "Lancement",
    desc: "Signature du partenariat exclusif Wayne et déploiement des premières stations pilotes.",
  },
  {
    year: "2026",
    title: "Expansion",
    desc: "25 stations opérationnelles à Abidjan et grandes villes du sud du pays.",
  },
  {
    year: "2028",
    title: "Consolidation",
    desc: "60 stations, couverture du nord et de l'ouest, dépôt pétrolier régional en service.",
  },
  {
    year: "2030",
    title: "Objectif",
    desc: "100 stations Wayne — couverture nationale complète et leadership régional confirmé.",
  },
];

// Real Côte d'Ivoire outline (processed: white bg → transparent, outline → white)
const CI_MAP_IMG = "/assets/ci-map.png";

// Cities positioned as percentage coordinates over the map image
// (values approximate the geography visible on the reference outline).
const CITIES = [
  { name: "Abidjan", x: 66, y: 84 },
  { name: "Yamoussoukro", x: 51, y: 60 },
  { name: "Bouaké", x: 55, y: 46 },
  { name: "Korhogo", x: 46, y: 22 },
  { name: "San Pédro", x: 34, y: 88 },
  { name: "Man", x: 20, y: 50 },
  { name: "Daloa", x: 34, y: 56 },
  { name: "Abengourou", x: 74, y: 56 },
  { name: "Bondoukou", x: 76, y: 36 },
];

function IvoryCoastMap() {
  return (
    <div className="relative w-full h-full">
      <img
        src={CI_MAP_IMG}
        alt="Carte de la Côte d'Ivoire"
        className="w-full h-full object-contain"
        style={{
          filter: "drop-shadow(0 0 24px rgba(232,93,38,0.15))",
        }}
      />
      {CITIES.map((c) => (
        <div
          key={c.name}
          className="absolute -translate-x-1/2 -translate-y-1/2 flex items-center gap-2"
          style={{ left: `${c.x}%`, top: `${c.y}%` }}
        >
          <span className="relative flex items-center justify-center">
            <span className="absolute w-4 h-4 rounded-full bg-[#E85D26]/40 kip-pulse" />
            <span className="relative w-2.5 h-2.5 rounded-full bg-[#E85D26] shadow-[0_0_8px_rgba(232,93,38,0.9)]" />
          </span>
          <span className="text-[10px] tracking-wide text-white/85 whitespace-nowrap font-medium">
            {c.name}
          </span>
        </div>
      ))}
    </div>
  );
}

export default function Vision() {
  return (
    <section
      id="vision"
      data-testid="vision-section"
      className="relative bg-[#0F1A2E] py-24 sm:py-28 overflow-hidden"
    >
      {/* Subtle radial */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-40 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at 20% 30%, rgba(232,93,38,0.18) 0%, transparent 50%), radial-gradient(ellipse at 80% 80%, rgba(232,93,38,0.10) 0%, transparent 50%)",
        }}
      />

      <div className="relative kip-container">
        <div className="grid lg:grid-cols-12 gap-16 items-start">
          {/* Left: heading + timeline */}
          <div className="lg:col-span-7 reveal">
            <span className="kip-overline">Vision 2030</span>
            <span className="kip-accent-bar mt-4" />
            <h2 className="font-display font-black text-white text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05]">
              <span className="text-[#E85D26]">100 stations</span> pour couvrir
              la Côte d'Ivoire.
            </h2>
            <p className="mt-6 text-white/70 text-lg leading-relaxed max-w-xl">
              Une feuille de route ambitieuse et progressive pour bâtir le plus
              grand réseau de stations-services nouvelle génération du pays.
            </p>

            {/* Timeline */}
            <div className="mt-12 relative">
              <div
                aria-hidden
                className="absolute left-3 top-0 bottom-0 w-px bg-[#E85D26]/40 lg:left-0 lg:top-8 lg:bottom-auto lg:h-px lg:w-full"
              />
              <div className="grid lg:grid-cols-4 gap-8 lg:gap-6">
                {MILESTONES.map((m, i) => (
                  <div
                    key={m.year}
                    data-testid={`vision-milestone-${i}`}
                    className="relative pl-10 lg:pl-0 lg:pt-14"
                  >
                    <div
                      className={`absolute w-3 h-3 rounded-full bg-[#E85D26] left-2 top-2 lg:left-0 lg:top-6 kip-glow`}
                    />
                    <div className="font-display font-black text-3xl text-white tracking-tight">
                      {m.year}
                    </div>
                    <div className="text-[#E85D26] text-xs uppercase tracking-[0.22em] font-bold mt-1">
                      {m.title}
                    </div>
                    <p className="text-white/70 text-sm mt-3 leading-relaxed">
                      {m.desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right: map */}
          <div className="lg:col-span-5 reveal">
            <div className="relative aspect-[4/5] max-w-md mx-auto">
              <IvoryCoastMap />
            </div>
            <div className="text-center mt-4 text-white/50 text-xs tracking-[0.24em] uppercase">
              Déploiement — Vision 2030
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
